import styled from 'styled-components';

export const animationSpeed = 200;
export const animationMargin = 400;

export const CardAnimateur = styled.div<{ $direction: string }>`
  &.entering,
  &.exiting,
  &.exited {
    opacity: 0;
    filter: blur(2px);
    transform: scaleX(1.15);
  }
  &.entering {
    margin-left: ${({ $direction }) =>
      $direction === 'left' ? `${animationMargin}px` : `-${animationMargin}px`};
  }
  &.exiting,
  &.exited {
    margin-left: ${({ $direction }) =>
      $direction === 'left' ? `-${animationMargin}px` : `${animationMargin}px`};
  }

  opacity: 1;
  transition: all ${animationSpeed}ms cubic-bezier(0.78, 0.14, 0.15, 0.86);
`;
